import {PIXI} from '@colonist/pixi'
import {SpriteView} from './SpriteView'
import {ACTIVE_OPACITY, INACTIVE_OPACITY} from '../ui_utils/Utils'
import {GeneralButtonView} from './GeneralButtonView'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'

export class SpriteButtonView extends GeneralButtonView {
    protected readonly assets: (SpriteView | PIXI.Container)[]
    private readonly iconDefaultSizeRatio: number

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, removePadding?: boolean, iconDefaultSizeRatio: number = 0.6) {
        super(x, y, w, h, container, removePadding)
        this.iconDefaultSizeRatio = iconDefaultSizeRatio
        this.assets = []
    }

    addCenteredIcon(icon: PIXI.Texture, overrideSize?: number) {
        const sizeRatio = overrideSize == undefined ? this.iconDefaultSizeRatio : overrideSize
        const newSizeY = this.viewContainer.height * sizeRatio
        const newSizeX = icon.width / icon.height * newSizeY
        const xMargin = (this.viewContainer.width - newSizeX) / 2
        const yMargin = (this.viewContainer.height - newSizeY) / 2
        const newIcon = new SpriteView(xMargin, yMargin, newSizeX, newSizeY, this.viewContainer, icon)
        this.assets.push(newIcon)
        this.centerIconInX(newIcon)
        this.centerIconInY(newIcon)
    }

    centerIconInX(asset: SpriteView | PIXI.Container) {
        const buttonBackgroundRightMargin = this.viewContainer.width * 0.02
        const xMargin = (this.viewContainer.width - buttonBackgroundRightMargin - asset.width) / 2
        asset.x = xMargin
    }

    centerIconInY(asset: SpriteView | PIXI.Container) {
        const buttonBackgroundRightMargin = this.viewContainer.height * 0.02
        const yMargin = (this.viewContainer.height - buttonBackgroundRightMargin - asset.height) / 2
        asset.y = yMargin
    }

    addAsset(asset: SpriteView | PIXI.Container) {
        this.assets.push(asset)
        if(asset.parent != undefined) asset.parent.removeChild(asset)
        this.viewContainer.addChild(asset)
    }

    highlight() {
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button_highlight), true)
    }

    removeHighlight() {
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button))
    }

    isSameTexture(texture: PIXI.Texture): boolean {
        for(const asset of this.assets) {
            const isContainer = (asset as SpriteView).texture === undefined
            if(isContainer) continue
            if((asset as SpriteView).texture == texture) return true
        }
        return false
    }

    updateTexture(texture: PIXI.Texture) {
        this.removeAllAssets()
        this.addCenteredIcon(texture)
    }

    activateOpacity() {
        this.updateOpacity(ACTIVE_OPACITY)
    }

    inactivateOpacity() {
        this.updateOpacity(INACTIVE_OPACITY)
    }

    isButtonOpactityActive(): boolean {
        for(const asset of this.assets) {
            if(asset.alpha == ACTIVE_OPACITY) return true
        }
        return false
    }

    protected updateOpacity(opacity: number) {
        for(const asset of this.assets) {
            if(asset.alpha == opacity) continue
            asset.alpha = opacity
        }
    }

    private removeAllAssets() {
        for(const asset of this.assets) {
            if(asset.parent == undefined) continue
            asset.parent.removeChild(asset)
        }
    }
}
